var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainersOnTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.998,
    height: 115.997,
    viewBox: "0 0 119.998 115.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-16 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M174.579,32a55.623,55.623,0,0,0-32.473,10.371l2.323,3.257a52,52,0,0,1,71.8,73.5,52.438,52.438,0,0,1-26.244,18.545l1.183,3.82A56.006,56.006,0,0,0,174.579,32Z",
    transform: "translate(-94.58 0)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M238.608,157.013a48.011,48.011,0,0,0-33.39-90.03l1.391,3.75a44.011,44.011,0,0,1,30.608,82.53Z",
    transform: "translate(-141.915 -24.001)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M264,96h4v4h-4Z",
    transform: "translate(-186.002 -48.001)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M0,0H4V4H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 110.171, 107.728)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M416,248h4v4h-4Z",
    transform: "translate(-300.003 -162.002)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M0,0H4V4H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 110.172, 68.268)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M0,0H4V4H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 96.263, 55.822)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M264,166a2,2,0,0,0,3,1.732l20.784-12-2-3.464L268,162.535V136h-4Z",
    transform: "translate(-186.002 -78.001)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M92,172h4v-4H92V148h4v-4H64V124h4v-4H64V100h4V96H24v4h4v20H24v4h4v20H16v4h4v20H16v4h4v20H16v4H96v-4H92Zm-4,20H58V172H88Zm0-24H58V148H88ZM32,100H60v20H32Zm0,24H60v20H32Zm-8,24H54v20H24Zm0,24H54v20H24Z",
    transform: "translate(0 -48.001)",
    fill: "#0671ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainersOnTime);
export default __webpack_public_path__ + "static/media/ContainersOnTime.fa5543941f7ddfbaac4ef7e7148c2667.svg";
export { ForwardRef as ReactComponent };